module.exports = __webpack_public_path__ + "media/images/area/area_fukuokaM400-ad4178fb046e9eb124ed1764dc8d3eb2.jpg";